<template>
  <div class="body">
    <!-- <moduleTitle title="进度查询"></moduleTitle> -->
    <!-- <search></search> -->
    <moduleTitle title="求职进度"></moduleTitle>
    <progressContent :list="list"></progressContent>
  </div>
</template>
<style lang="scss" scoped>
.body {
  width: 80%;
  margin: 40px auto;
}
</style>
<script>
import moduleTitle from "@/components/moduleTitle.vue";
// import search from "./components/search.vue";
import progressContent from "./components/progress.vue";
import request from "@/api/jobProgress";
export default {
  components: {
    moduleTitle,
    // search,
    progressContent
  },
  data() {
    return { list: [] };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    async getInfo() {
      const para = {
        yhid: this.$store.state.userInfo.yhid
      };
      const data = await request.getJobProgress(para);
      this.list = data.ds;
    }
  }
};
</script>
